// eslint-disable

const routes = [

  // Full Page Layout
  {
    path: '/',
    component: () => import('@/layouts/FullPage/FullPage'),
    children: [
      {
        path: '/invites',
        name: 'InvitePage',
        component: () => import('@/views/pages/InvitePage.vue'),
        props: (route) => ({
          inviterId: route.query.id,
          profilePhotoUrl: route.query.profilePhotoUrl,
          inviterName: route.query.inviterName,
        }),
        meta: {},
      },
    ],
  },
  {
    name: 'Home',
    path: '/*',
    redirect: { name: 'InvitePage' },
  },
];

export default routes;
